import { AnyAction } from 'redux';
import sendRequestDesignDataPostMessageOperation
  from 'src/store/app/operation/sendRequestDesignDataPostMessageOperation';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'src/store/index';

const sendRequestDesignDataPostMessageToUpdateOrderItemOperation = () => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => {
  const message = {
    type: MESSAGE_TYPE['host.updateOrderItem'],
  };
  dispatch(sendRequestDesignDataPostMessageOperation(message, true));
};

export default sendRequestDesignDataPostMessageToUpdateOrderItemOperation;
